module.exports = __webpack_public_path__ + "media/images/footer_about-5f65f295f8a4fd19b91917a9d7ce3901.png";